import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class CashReceiptService extends GenericService {
  constructor() {
    super('/cash_receipts', axiosInstance);
  }
}
export default new CashReceiptService(); 